import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["userSelect", "accessLevel"];

  handleSubmit(event) {
    const selectedOption = this.userSelectTarget.selectedOptions[0];
    const existingLevel = selectedOption.dataset.existingLevel;
    const userEmail = selectedOption.dataset.userEmail;
    const newAccessLevel = this.accessLevelTarget.value;

    // If user already has access and the level is being changed, show confirmation
    if (existingLevel && existingLevel !== newAccessLevel) {
      const message = `User ${userEmail} already has "${existingLevel}" access. Change to "${newAccessLevel}"?`;
      if (!confirm(message)) {
        event.preventDefault();
      }
    }
  }
}
